import { useNavigate } from "react-router-dom"
import { Button, Col, FormGroup, Input, Nav, Navbar, Row } from "reactstrap"
import AllProducts from "../components/AllProducts"
import Base from "../components/Base"
import OwlCarousel from 'react-owl-carousel';
import { useEffect, useState } from "react";
import { getAllCategories, searchProduct } from "../services/product-service";
import Footer from "../components/Footer";
import store_img from "../assets/img/store1.webp";
import PrescriptionOrder from "../components/PrescriptionOrder";
import SearchProductHome from "../components/SearchProductHome";
import { BASE_URL } from "../services/helper";
import Categories from "../components/Categories";
import FeaturedProducts from "../components/FeaturedProducts";

const Landing=({props})=>{
    let navigate =useNavigate()
    const [modal, setModal] = useState(false);
    const [page,setPage] = useState({
        "totalPages":'',
        "pageSize":'',
        "pageNumber":'',
        "totalElements":'',
        "lastPage":false,
        "products":[]

    })
    const toggle = () => setModal(!modal);

    

    const [categories,setCategories]=useState([])

    useEffect(()=>{
        getAllCategories().then(data=>{
            setCategories(data)
            console.log(categories)
        },[])
    },[])
    useEffect(()=>{
        getAllCategories().then(data=>{
            //setCategories(data)
            console.log(categories)
        },[])
    },[categories])

    const goToCategory=()=>{
       const catId= document.getElementById("category").value
        navigate("/category/"+catId)
    }

 

    const options = {
        margin: 30,
        responsiveClass: true,
        autoplay: true,
        smartSpeed: 1000,
        responsive: {
            0: {
                items: 1,
                loop:true
            },
            400: {
                items: 1,
                loop:true
            },
            600: {
                items: 2,
                loop:true
            },
            700: {
                items: 3,
                loop:true
            },
            1000: {
                items: 5,
                loop:true
            }
        },
      };
    return(
        <Base>
            <>

            <Navbar dark color="dark mb-5">
            <Nav className="w-100 row">
                <FormGroup className="w-100 input-group">

                <Input id="category" onChange={()=>goToCategory()} type="select" className="bg-primary mx-md-1 form-control" style={{maxWidth:"65px"}} >
                                        <option value="home"  disabled selected > ALL </option>
                                        {
                                            categories.map((category,index)=>(
                                                <option className="px-1" key={index} id={category.id}  value={category.id}  >{category.name}</option>
                                            ))
                                        }
                                        
                </Input>
                
                <SearchProductHome />
                </FormGroup>
            
            </Nav>

        </Navbar>

            <div class="container-fluid mb-3 mt-5">
        <div class="row px-xl-5">
            <div class="col-lg-8">
                <div id="header-carousel" class="carousel slide carousel-fade mb-30 mb-lg-0" data-ride="carousel">
                    <ol class="carousel-indicators">
                        <li data-target="#header-carousel" data-slide-to="0" class="active"></li>
                        <li data-target="#header-carousel" data-slide-to="1"></li>
                        <li data-target="#header-carousel" data-slide-to="2"></li>
                    </ol>
                    <div class="carousel-inner">
                        <div class="carousel-item position-relative active" style={{height: "430px"}}>
                            <img class="position-absolute w-100 h-100" src="img/kidneyStone.jpg" style={{objectFit:"fill"}} />
                            
                        </div>
                        <div class="carousel-item position-relative" style={{height: "430px"}}>
                            <img class="position-absolute w-100 h-100" src="img/oldage.webp" style={{objectFit: "fill"}} />
                            
                        </div>
                        <div class="carousel-item position-relative" style={{height: "430px"}}>
                            <img class="position-absolute w-100 h-100" src="img/vitiligo.png" style={{objectFit: "fill"}} />
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="product-offer mb-30" style={{height: "200px"}} >
                    <img class="img-fluid" src={store_img} alt="" style={{objectFit:"fill"}} />
                    <div class="offer-text">
                        <h6 class="text-white text-uppercase">Save 20%</h6>
                        <h3 class="text-white mb-3">All Homoeopathic Medicine</h3>
                        <a onClick={()=>navigate("/home/0")} class="btn btn-primary">Shop Now</a>
                    </div>
                </div>
                <div class="product-offer mb-30" style={{height: "200px"}}>
                    <img class="img-fluid" src="img/prescription.png" alt="" style={{objectFit:"contain"}} />
                    <div class="offer-text">
                        <h6 class="text-white text-uppercase">Save 50%</h6>
                        <h3 class="text-white mb-3">Buy Remedies</h3>
                        <a onClick={()=>toggle()} class="btn btn-primary"> <i class="fas fa-camera text-dark"></i> Upload Prescription</a>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <div class="container-fluid pt-5">
        <div class="row px-xl-5 pb-3">
            <div class="col-lg-3 col-md-6 col-sm-12 pb-1">
                <div class="d-flex align-items-center bg-light mb-4" style={{padding: "30px"}}>
                    <h1 class="fa fa-check text-primary m-0 mr-3"></h1>
                    <h5 class="font-weight-semi-bold m-0">Natural Product</h5>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 pb-1">
                <div class="d-flex align-items-center bg-light mb-4" style={{padding: "30px"}}>
                    <h1 class="fa fa-shipping-fast text-primary m-0 mr-2"></h1>
                    <h5 class="font-weight-semi-bold m-0">Fast Shipping</h5>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 pb-1">
                <div class="d-flex align-items-center bg-light mb-4" style={{padding: "30px"}}>
                    <h1 class="fas fa-exchange-alt text-primary m-0 mr-3"></h1>
                    <h5 class="font-weight-semi-bold m-0">0 Side Effect</h5>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 pb-1">
                <div class="d-flex align-items-center bg-light mb-4" style={{padding: "30px"}}>
                    <h1 class="fa fa-phone-volume text-primary m-0 mr-3"></h1>
                    <h5 class="font-weight-semi-bold m-0">24/7 Support</h5>
                </div>
            </div>
        </div>
    </div>

    {/* category start */}

    <div class="container-fluid pt-5">
        <h2 class="section-title position-relative text-uppercase mx-xl-5 mb-4"><span class="bg-secondary pr-3">Categories</span></h2>
        <div class="row px-xl-5 pb-3"  >
        
            <Categories categories={categories} />
            
        
            
        </div>
    </div>

    {/* category end */}

     {/* Featured Products start */}

        <FeaturedProducts />

    {/* Featured Products end */}

        {/* <!-- Appointment Offer Start --> */}

    <div class="container-fluid pt-5 pb-3">
        <div class="row px-xl-5">
            <div class="col-md-6">
                <div class="product-offer mb-30" style={{height: "300px"}}>
                    <img class="img-fluid" src="img/doctor1.jpg" alt="" />
                    <div class="offer-text">
                        <h6 class="text-white text-uppercase">100% Refund after starting treatment</h6>
                        <h3 class="text-white mb-3">Free Online Doctor Cosultancy</h3>
                        <a disabled onClick={()=>navigate("/consultation")} class="btn btn-primary">Contact Now</a>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="product-offer mb-30" style={{height: "300px"}}>
                    <img class="img-fluid" src="img/homeoClinic.jpg" alt="" />
                    <div class="offer-text">
                        <h6 class="text-white text-uppercase">Save 100% </h6>
                        <h3 class="text-white mb-3">Free Book Appointment and visit</h3>
                        <a disabled onClick={()=>navigate("/aboutus")} class="btn btn-primary">Schedule</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Appointment Offer End --> */}


    

    <div className="container-fluid py-5 px-xl-5 mx-xl-2">
        <OwlCarousel className="slider-items owl-carousel vendor-carousel" {...options}>
                    <div class="item bg-light p-4">
                        <img src="img/sbl.jpeg" alt="" />
                    </div>
                    <div class="item bg-light p-4">
                        <img src="img/adven.png" alt="" />
                    </div>
                    <div class="item bg-light p-4">
                        <img src="img/reckeweg.jpg" alt="" />
                    </div>
                    <div class="item bg-light p-4">
                        <img src="img/wheezal.jpeg" alt="" />
                    </div>
                    <div class="item bg-light p-4">
                        <img src="img/schwabe.jpeg" alt="" />
                    </div>
                    <div class="item bg-light p-4">
                        <img src="img/bjain.webp"  alt="" />
                    </div>

        </OwlCarousel>
    </div>

    <PrescriptionOrder props={[toggle,modal]} ></PrescriptionOrder>
            </>

           
            
        </Base>
    )
}

export default Landing